import React, {FC} from 'react';

import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Component.
 */

export const ReadStatusInfoBubbleHighlight: FC<InfoBubbleInstanceProps> = ({targetRef}) => {
  const context = useInfoBubblesContext();

  return (
    <InfoBubble
      {...context}
      type={OnboardingTipTypesEnum.READ_STATUS_HIGHLIGHT}
      targetRef={targetRef}
      position="top"
      isInteractive
    />
  );
};
